import { LocalSettings } from "../LocalSettings";

export class DashboardSettings {
  private static readonly MODULE = "dashboard";

  static getGetStartedMinimized(): boolean {
    return LocalSettings.loadSetting(this.MODULE, "getStartedMinimized", false);
  }

  static setGetStartedMinimized(minimized: boolean): void {
    LocalSettings.saveSetting(this.MODULE, "getStartedMinimized", minimized);
  }
}
